module.exports = __webpack_public_path__ + "assets/ff92cbadf25a193a925ee8633d5bc2c4.jpg";